export enum FEATURE_NAMES {
  MVS_DASHBOARD = "MVS_DASHBOARD",
  MVS_SHIPMENTS = "MVS_SHIPMENTS",
  MVS_AIR_SHIPMENTS = "MVS_AIR_SHIPMENTS",
  MVS_DND = "MVS_DND",
  MVS_PORT_CONGESTION = "MVS_PORT_CONGESTION",
  MVS_EMISSIONS = "MVS_EMISSIONS",
  MVS_UNAUTHORIZED = "MVS_UNAUTHORIZED",
  MVS_WORKSPACES = "MVS_WORKSPACES",
  MVS = "MVS",
  MVS_SUPPORT = "MVS_SUPPORT",
  MVS_RISK_MANAGEMENT = "MVS_RISK_MANAGEMENT",
  MVS_ASYNC_DOWNLOAD = "MVS_ASYNC_DOWNLOAD",
  MVS_TERMS_AND_CONDITIONS = "MVS_TERMS_AND_CONDITIONS",
  MVS_RISK_MANAGEMENT_IMPACTED_SKUS = "MVS_RISK_MANAGEMENT_IMPACTED_SKUS",
  MVS_RISK_MANAGEMENT_LOCATION_SUBSCRIPTION = "MVS_RISK_MANAGEMENT_LOCATION_SUBSCRIPTION",
  MVS_RISK_MANAGEMENT_SUBSCRIBE_LOCATIONS = "MVS_RISK_MANAGEMENT_SUBSCRIBE_LOCATIONS",
  MVS_FILTERS = "MVS_FILTERS",
  MVS_ASYNC_UPLOAD = "MVS_ASYNC_UPLOAD",
  MVS_TEMPLATE_DOWNLOAD = "MVS_TEMPLATE_DOWNLOAD",
  MVS_REPORTING = "MVS_REPORTING",
  MVS_CONTROL_TOWER = "MVS_CONTROL_TOWER",
  MVS_CARRIER_PERFORMANCE = "MVS_CARRIER_PERFORMANCE",
  MVS_METERING = "MVS_METERING",
  MVS_BOOKINGS = "MVS_BOOKINGS"
}

export enum METRIC_TYPE {
  API_CALL_FAILURE = "API_CALL_FAILURE",
  API_CALL_LATENCY = "API_CALL_LATENCY",
  USER_ACTION = "USER_ACTION"
}

export enum CLIENT_ERROR_CATEGORY {
  UNCAUGHT_JS = "UNCAUGHT_JS",
  UNHANDLED_REJECTION = "UNHANDLED_REJECTION",
  CHUNK_LOAD = "CHUNK_LOAD"
}
